<template>
  <div class="user-select-wrapper">
    <label v-if="label" class="mb-1">{{ label }}</label>
    <div class="user-select-wrapper">
      <input
        v-model="searchQuery"
        :placeholder="displayValue || placeholder"
        :disabled="disabled"
        :readonly="!showDropdownList"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        @input="filterOptions"
        @focus="showDropdown"
        @blur="hideDropdown"
        @click="showDropdown"
        @touchstart="showDropdown"
        class="user-search-input"
      />
      <div class="user-select-arrow" :class="{ 'rotated': showDropdownList }">
        <i class="fas fa-chevron-down"></i>
      </div>
      <div 
        v-if="showDropdownList" 
        class="user-dropdown"
        :class="{ 'show': showDropdownList }"
        @touchstart="preventClose"
        @touchend="preventClose"
      >
        <div class="user-dropdown-content">
          <div 
            v-if="allowNull"
            class="user-option"
            :class="{ 'selected': selectedValue === null }"
            @click="selectOption(null)"
            @touchend="handleTouchSelect(null, $event)"
            @mousedown="handleMouseDown(null, $event)"
            @touchstart.passive=""
          >
            {{ nullText }}
          </div>
          <div 
            v-for="option in filteredOptions" 
            :key="option.value"
            class="user-option"
            :class="{ 'selected': selectedValue === option.value }"
            @click="selectOption(option.value)"
            @touchend="handleTouchSelect(option.value, $event)"
            @mousedown="handleMouseDown(option.value, $event)"
            @touchstart.passive=""
          >
            {{ option.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomDropdown",
  
  props: {
    // Основные пропсы
    value: {
      type: [String, Number, null],
      default: null
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Выберите значение...'
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    
    // Настройки для null значения
    allowNull: {
      type: Boolean,
      default: false
    },
    nullText: {
      type: String,
      default: 'Все'
    },
    
    // Настройки поиска
    searchable: {
      type: Boolean,
      default: true
    },
    
    // Размер
    size: {
      type: String,
      default: 'sm',
      validator: value => ['sm', 'md', 'lg'].includes(value)
    }
  },
  
  data() {
    return {
      showDropdownList: false,
      searchQuery: '',
      filteredOptions: [],
      selectedValue: null,
      displayValue: ''
    };
  },
  
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.selectedValue = newValue;
        this.updateDisplayValue();
      }
    },
    
    options: {
      immediate: true,
      handler() {
        this.filteredOptions = [...this.options];
      }
    }
  },
  
  methods: {
    showDropdown() {
      this.showDropdownList = true;
      this.filteredOptions = [...this.options];
      this.searchQuery = '';
    },
    
    hideDropdown() {
      setTimeout(() => {
        this.showDropdownList = false;
        this.searchQuery = ''; // Очищаем поисковый запрос при закрытии
      }, 150);
    },
    
    preventClose(event) {
      event.stopPropagation();
    },
    
    filterOptions() {
      if (!this.searchQuery.trim()) {
        this.filteredOptions = [...this.options];
      } else {
        const query = this.searchQuery.toLowerCase();
        this.filteredOptions = this.options.filter(option => 
          option.text.toLowerCase().includes(query)
        );
      }
    },
    
    selectOption(value) {
      this.selectedValue = value;
      this.updateDisplayValue();
      this.showDropdownList = false;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    
    handleTouchSelect(value, event) {
      event.preventDefault();
      event.stopPropagation();
      this.selectOption(value);
    },
    
    handleMouseDown(value, event) {
      if (event.type === 'mousedown' && event.buttons === 1) {
        event.preventDefault();
        event.stopPropagation();
        this.selectOption(value);
      }
    },
    
    updateDisplayValue() {
      if (this.selectedValue === null) {
        this.displayValue = this.nullText;
      } else {
        const selectedOption = this.options.find(option => option.value === this.selectedValue);
        this.displayValue = selectedOption ? selectedOption.text : '';
      }
    }
  }
};
</script>
